import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { runInAction } from "mobx";
import { http, HttpResponse } from "msw";
import OpenDataSoftCatalogGroup from "../../../../lib/Models/Catalog/CatalogGroups/OpenDataSoftCatalogGroup";
import Terria from "../../../../lib/Models/Terria";
import { worker } from "../../../mocks/browser";
import facets from "../../../../wwwroot/test/ods/facets.json";
import datasets from "../../../../wwwroot/test/ods/datasets.json";
import datasetsCount101Response1 from "../../../../wwwroot/test/ods/datasets-over-100-1.json";
import datasetsCount101Response2 from "../../../../wwwroot/test/ods/datasets-over-100-2.json";
describe("OpenDataSoftCatalogGroup", function () {
  let terria;
  let odsGroup;
  beforeEach(function () {
    worker.use(http.get("https://example.com/api/v2/catalog/facets/", () => HttpResponse.json(facets)));
    terria = new Terria();
    odsGroup = new OpenDataSoftCatalogGroup("test", terria);
  });
  it("has a type", function () {
    expect(odsGroup.type).toBe("opendatasoft-group");
  });
  describe("loads facets", function () {
    beforeEach(function () {
      worker.use(http.get("https://example.com/api/v2/catalog/datasets/", () => HttpResponse.json(datasets)));
      runInAction(() => {
        odsGroup.setTrait("definition", "url", "https://example.com");
      });
    });
    it("loadsNestedMembers", async function () {
      var _environmentalSensors;
      await odsGroup.loadMembers();
      const facets = odsGroup.memberModels;
      expect(facets.length).toEqual(6);
      const featureFacet = facets[1];
      await featureFacet.loadMembers();
      expect(featureFacet.memberModels.length).toEqual(4);
      const geoFeatureFacet = featureFacet.memberModels[1];
      await geoFeatureFacet.loadMembers();
      expect(geoFeatureFacet.memberModels.length).toEqual(6);
      const environmentalSensors = geoFeatureFacet.memberModels[1];
      expect(environmentalSensors.type).toBe("opendatasoft-item");
      expect(environmentalSensors.name).toBe("Environmental sensors");
      expect((_environmentalSensors = environmentalSensors.description) === null || _environmentalSensors === void 0 ? void 0 : _environmentalSensors.length).toBe(244);
      expect(environmentalSensors.datasetId).toBe("weather-stations");
    });
  });
  describe("loads over 100 datasets (in multiple requests)", function () {
    beforeEach(function () {
      // Note these two responses don't actually return over 100 datasets
      // Both JSON files have "total_count": 101 - and 6 different datasets each
      // So we expect total 12 datasets
      worker.use(http.get("https://example.com/api/v2/catalog/datasets/", _ref => {
        let {
          request
        } = _ref;
        const url = new URL(request.url);
        if (url.searchParams.get("limit") !== "100" || url.searchParams.get("order_by") !== "title asc" || url.searchParams.get("refine") !== "features:geo" || url.searchParams.get("where") !== 'features = "geo" OR features = "timeserie"') {
          return HttpResponse.error();
        }
        const offset = url.searchParams.get("offset");
        if (offset === "100") return HttpResponse.json(datasetsCount101Response2);
        return HttpResponse.json(datasetsCount101Response1);
      }));
      runInAction(() => {
        odsGroup.setTrait("definition", "url", "https://example.com");
      });
    });
    it("loadsNestedMembers", async function () {
      var _environmentalSensors2;
      await odsGroup.loadMembers();
      const facets = odsGroup.memberModels;
      expect(facets.length).toEqual(6);
      const featureFacet = facets[1];
      await featureFacet.loadMembers();
      expect(featureFacet.memberModels.length).toEqual(4);
      const geoFeatureFacet = featureFacet.memberModels[1];
      await geoFeatureFacet.loadMembers();
      expect(geoFeatureFacet.memberModels.length).toEqual(12);
      const environmentalSensors = geoFeatureFacet.memberModels[1];
      expect(environmentalSensors.type).toBe("opendatasoft-item");
      expect(environmentalSensors.name).toBe("Environmental sensors");
      expect((_environmentalSensors2 = environmentalSensors.description) === null || _environmentalSensors2 === void 0 ? void 0 : _environmentalSensors2.length).toBe(244);
      expect(environmentalSensors.datasetId).toBe("weather-stations-2");
    });
  });
});